<app-survey-frame-list>
  <app-survey-frame-list-template
    template
    [id]="address.id"
    [index]="index"
    #frame
  >
    <div class="templateHeader" header>
      <div class="header-part">
        <mat-icon *ngIf="getErrors(address.id)" style="color: red"
          >warning</mat-icon
        >
      </div>
      <div class="header-part">
        <ng-container *ngIf="!inPortrait; else keysPortrait">
          <div class="vertical-flex">
            <span class="bold">
              <span i18n="@@general.address">Address</span>
              {{ index }}
            </span>
            <span>{{ address?.lomKey ?? "-" }}</span>
          </div>
        </ng-container>
        <ng-template #keysPortrait>
          <div class="vertical-flex portrait">
            <span>
              <span class="bold">A{{ index }}</span> -
              <span class="small">{{ address?.lomKey ?? "" }}</span>
            </span>
          </div>
        </ng-template>
      </div>
      <div class="header-part" style="margin-left: 1rem">
        <span class="address"> {{ address.getFullAddress() }}</span>
      </div>
      <div class="header-part grow"></div>
      <div class="header-part">
        <div class="circle" *ngIf="address.isMainAddress">
          <mat-icon class="material-icons-outlined"> home </mat-icon>
        </div>
      </div>
      <div class="header-part no-wrap">
        <span class="photo-count"
          ><span [class.red-count]="!viewmodel?.facadePhotos?.length">{{
            viewmodel?.facadePhotos?.length ?? 0
          }}</span>
          | <span>{{ viewmodel?.detailPhotos?.length ?? 0 }}</span></span
        >
      </div>
    </div>
    <div detail>
      <div class="holder">
        <div
          style="display: flex; align-items: center; gap: 1rem"
          class="sub-title"
          [class.required]="
            address.isMainAddress &&
            survey.building.buildingType != BuildingTypeEnum.NotInUse
          "
        >
          <mat-icon
            *ngIf="getErrors(address.id, 'outsidePhotoFacadePhotoSubTitle')"
            style="color: red"
            >warning
          </mat-icon>
          <span i18n="@@general.photo.facade">Photo facade</span>
        </div>
        <div class="row">
          <div class="col-md-12">
            <app-photo-and-remark
              [photos]="viewmodel.facadePhotos"
              [limit]="1"
              [isAuthCanWrite]="isAuthCanWrite"
              [camera]="camera"
              [cameraLayer]="cameraLayer"
              [surveyId]="survey.id"
              [addressId]="address.id"
              [surveyType]="surveyType.Outside"
              [surveyPhotoType]="surveyPhotoType.Facade"
              [isInsidePhoto]="false"
              componentDescriptionTitle="Facade Photo"
            >
            </app-photo-and-remark>
          </div>
        </div>
        <div class="sub-title" i18n="@@general.facade.details">
          Facade details
        </div>
        <div class="row">
          <div class="col-md-12">
            <app-photo-and-remark
              [photos]="viewmodel.detailPhotos"
              [limit]="75"
              [isAuthCanWrite]="isAuthCanWrite"
              [isInsidePhoto]="false"
              [camera]="camera"
              [cameraLayer]="cameraLayer"
              [surveyId]="survey.id"
              [addressId]="address.id"
              [surveyType]="surveyType.Outside"
              [surveyPhotoType]="surveyPhotoType.Detail"
              componentDescriptionTitle="Facade Details"
            >
            </app-photo-and-remark>
          </div>
        </div>
      </div>
    </div>
  </app-survey-frame-list-template>
</app-survey-frame-list>
